import type { IFormxRepository, ReorderInput } from '../repositories/IFormxRepository.js';

interface Deps { formxRepository: IFormxRepository; }

export function createReorderFormxFieldsUseCase({ formxRepository }: Deps) {
  return async function reorderFormxFields(updates: ReorderInput): Promise<void> {
    return formxRepository.reorderFields(updates);
  };
}
